import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm, FormArray, FormControl, ValidationErrors, AbstractControl } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { BaseComponent } from '../base-form/base-form.component';
import { MatStepper } from '@angular/material/stepper';
import _, { map } from 'lodash';
import moment from 'moment-timezone';
import { EventLessonEntityComponent } from '../event-lesson-entity/event-lesson-entity.component';
import { environment } from 'src/environments/environment';
import { BaseEnrollmentComponent } from '../../enrollment/base-enrollment/base-enrollment.component';
import { HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError, forkJoin } from 'rxjs';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PaymentReceiptComponent } from '../../payments/payment-receipt/payment-receipt.component';
import { CurrencyService } from '../../../services/currency.service';
import { LocalizationService } from 'src/app/services/localization.service';
import { getTaxTypeShortLabel } from 'src/app/constants/tax.constants';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-enrollment-entity',
  templateUrl: './enrollment-entity.component.html',
  styleUrls: ['./enrollment-entity.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EnrollmentEntityComponent extends BaseEnrollmentComponent implements OnInit {

  override eckType = "packages";
  override bundle = "enrollment";
  override entityId = this._injectedDialogData['data']['EntityID'];

  field_enrollment_name: any;
  scheduledPayment_list = [];
  scheduledPaymentEditMode: boolean;
  scheduledPaymentEditIndex: number;
  // executives = [];
  // executiveEditMode: boolean;
  instructor_percentage_list = [];
  instructorPercentageEditMode: boolean;
  instructorPercentageEditIndex: number;

  is_pay_in_full: boolean;
  is_use_installments: boolean;
  override interval: number = 1;

  discountTotal;
  displayDiscountTotalString;

  eventCount;
  lessonCountDisabled: boolean;
  isMiscOrSundry: boolean = false;
  studioAddress: any;
  studioPhone: any;
  studioEmail: any;
  studioWebsite: any;
  studioName: any;
  console: any;
  inclusiveTaxRate: number = 0;
  exclusiveTaxRate: number = 0;
  // Rate last written to field_tax_percentage by config resolution; used to
  // detect (and preserve) a manual Taxes % override across sale-date changes.
  private lastResolvedTaxRate: number | null = null;
  private taxModeResolved = false;
  studentBalanceWarning: string;
  deCategoryPriceWarning: string;
  scheduledPaymentsOutOfDate: boolean = false;
  private isGeneratingPayments: boolean = false;

  studentBalanceData: any;

  // Enrollment agreement template (activeTemplateKey lives on BaseEnrollmentComponent)
  activeAgreementId: string = '';

  // Payment tracking for receipt functionality
  latestPaymentId: string | number = null;

  // Built in ngOnInit from the base class's already-injected StudioConfigService,
  // NOT via inject()/constructor DI (Angular 13 NG0203 on the manual
  // ComponentFactory create path these dialogs use). Mirrors how
  // BaseEnrollmentComponent constructs its own LocalizationService.
  private currencyService!: CurrencyService;

  onAutoCompleteStudentLoadInstructorExecutive($event) {
    const studentId = this.regexStudentName($event.option.value);

    this._entityRESTService.getEntity('student_accounts', 'student_account', studentId)
      .subscribe(studentData => {
        // Update the field_executive form control
        if (studentData?.['field_executive']?.uid) {
          this.enrollmentForm.patchValue({
            field_executive: studentData['field_executive'].uid
          });
        }

        // // Update the first field_instructor form control
        const instructorPercentages = this.enrollmentForm.get('field_instructor_percentages') as FormArray;
        if (instructorPercentages.length > 0) {
          if (studentData?.['field_teacher']?.uid) {
            instructorPercentages.at(0).patchValue({
              field_instructor: studentData['field_teacher'].uid
            });
          }
        } else {
          // If no instructor percentage exists, add a new one with the default values
          this.instructorPercentageIncrement();
          if (studentData?.['field_teacher']?.uid) {
            instructorPercentages.at(0).patchValue({
              field_instructor: studentData['field_teacher'].uid
            });
          }
        }
      });
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // Load studio information for all action types
    this._drupalRESTService.httpGET('/api_rest/v1/getStudioInformation')
      .subscribe(data => {
        this.studioInformationConfig = data;
      }, error => {
        LoggerService.error('Error fetching studio information in enrollment-entity:', error);
      });

    // Load the enrollment agreement template key
    this.loadAgreementTemplateKey();

    // Initialize tosAccepted based on data
    if (this.entityData?.field_tos_accepted_date) {
      this.tosAccepted = true;
    } else if (this.enrollmentForm?.get('field_tos_accepted_date')?.value) {
      this.tosAccepted = true;
    } else {
      this.tosAccepted = false;
    }

    // Validate DE category price
    setTimeout(() => {
      this.validateDECategoryPrice();
    });

    // Validate student balance: fires on autocomplete selection AND on
    // prefilled field_student (Appointment Details "Enrollment" button, etc.),
    // since _loadFieldsData patches the form async via setTimeout.
    this.enrollmentForm.get('field_student')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.checkStudentBalanceLimit(value);
        } else {
          this.studentBalanceWarning = null;
          this.studentBalanceData = null;
        }
      });
    if (this.enrollmentForm.get('field_student').value) {
      this.checkStudentBalanceLimit(this.enrollmentForm.get('field_student').value);
    }

    this.agreementFormGroup = this._formBuilder.group({
      field_nothing: [''],
    });

    // completionFormGroup is already initialized at property declaration to avoid change detection errors

    // Signature initialization
    setTimeout(() => {
      if (this.signatureStudent) {
        this.signatureInit(this.signatureStudent, 'student');
      }
      if (this.signatureStudio) {
        this.signatureInit(this.signatureStudio, 'studio');
      }
      // Only initialize parent signature if it's already visible (previously signed or shown)
      if (this.signatureParent && (this.detectSignatureParent || this.entityData?.field_parent_guardian_signature)) {
        this.signatureInit(this.signatureParent, 'parent');
      }
    }, 0);

    // Pull current tax rate.
    if (this.actionType == "create") {
      this._fieldsService.getTaxRateConfig().subscribe(data => {
        // this.enrollmentForm.get("field_tax_percentage").setValue(data?.[0]?.['value']);
        this.loadTaxRateFromConfig();
      });
    } else {
      // Edit mode keeps the stored Taxes % (the rate the enrollment was sold
      // at) but still needs the studio's tax MODE: whether the rate sits inside
      // the price or on top, and the per-tax rounding rows. Without it every
      // stored rate is treated as tax-on-top, which misstates Total Investment
      // and field_taxes for inclusive-tax studios.
      this.loadTaxModeFromConfig();
    }

    this.getUniquePaymentID()
      .subscribe(data => {
        this.paymentID = data;
        // this.setFormMode("create");
      });

    // This is causing problems.
    // this.instructorPercentageIncrement();


    // Set up scheduled payments validation
    this.setupScheduledPaymentsValidation();
  }

  private setupScheduledPaymentsValidation() {
    // In edit mode the Pay In Full / Installments radios are never clicked, so
    // is_use_installments stays unset and both the out-of-date warning and the
    // Generate Payment Plan button never show. Sync it from the form value
    // (patched async when editing an existing enrollment).
    const structureControl = this.enrollmentForm.get('field_payments_structure');
    if (structureControl) {
      this.is_use_installments = structureControl.value === 'installments';
      structureControl.valueChanges.subscribe(value => {
        this.is_use_installments = value === 'installments';
      });
    }

    // setFormValues matches form controls to entity fields by substring, so
    // the edit-mode load can leak field_payments_structure ('paid_in_full')
    // into field_payments_structure_type. An invalid type leaves the
    // installments builder half-rendered: no Weekly/Monthly/By The Lesson
    // button active and a bare interval input. Reset to null so the builder
    // shows its clean pick-a-type state instead.
    const validStructureTypes = ['weekly', 'monthly', 'by_the_lesson'];
    const structureTypeControl = this.enrollmentForm.get('field_payments_structure_type');
    if (structureTypeControl) {
      // Empty string must sanitize to null too. The template hides the
      // interval/date inputs with a "value == null" check, so '' leaves them
      // visible with no type selected.
      if (structureTypeControl.value != null && !validStructureTypes.includes(structureTypeControl.value)) {
        structureTypeControl.setValue(null);
      }
      structureTypeControl.valueChanges.subscribe(value => {
        if (value != null && !validStructureTypes.includes(value)) {
          structureTypeControl.setValue(null);
        }
      });
    }

    // Track changes to key fields that affect payment calculations
    const fieldsToWatch = [
      'field_enrollment_lesson_price',
      'field_enrollment_lesson_count',
      'field_discount_type',
      'field_discount',
      'field_tax_percentage',
      'field_down_payment_amount'
    ];

    // Loaded decimals arrive as storage-scale strings ("0.000") and get
    // rewritten as numbers (0) and back by bindings after the load. Only a
    // change in the value itself can invalidate the plan, so compare the
    // normalized value and ignore rewrites that leave it the same.
    const normalize = (value: any) => {
      const n = parseFloat(value);
      return isNaN(n) ? (value ?? '') : n;
    };
    fieldsToWatch.forEach(fieldName => {
      const control = this.enrollmentForm.get(fieldName);
      let lastValue = normalize(control?.value);
      control?.valueChanges.subscribe(value => {
        const nextValue = normalize(value);
        const unchanged = nextValue === lastValue;
        lastValue = nextValue;
        // formDataLoaded is false only while setFormValues patches the saved
        // entity into the form (edit mode load). Capture it now, before the
        // timeout, or the load itself flags the payments as out of date.
        const isInitialLoad = !this.formDataLoaded;
        if (unchanged) {
          return;
        }
        // Delay validation to next tick to ensure form values are updated
        setTimeout(() => {
          if (!isInitialLoad) {
            this.checkScheduledPaymentsValidity();
          }
        }, 0);
      });
    });
  }

  private checkScheduledPaymentsValidity() {
    // Skip validation during payment generation to prevent interference
    if (this.isGeneratingPayments) return;

    const scheduledPayments = this.enrollmentForm.get('field_scheduled_payments') as FormArray;
    const paymentsStructure = this.enrollmentForm.get('field_payments_structure')?.value;

    if (scheduledPayments.length === 0) return;

            // For Pay In Full: automatically recalculate the single payment
    if (paymentsStructure === 'paid_in_full' && this.is_pay_in_full && scheduledPayments.length === 1) {
      LoggerService.log('Auto-recalculating Pay In Full amount');

      const subtotal = this.calcDiscountedSubtotal();
      const taxAmount = this.calculateEstimatedTax(subtotal);

      LoggerService.log('Before update:', {
        currentPaymentAmount: scheduledPayments.at(0).get('field_payment_amount').value,
        newTotal: subtotal.toFixed(2),
        taxAmount,
        subtotal
      });

      scheduledPayments.at(0).patchValue({
        field_payment_amount: subtotal.toFixed(2),
        field_tax_amount: taxAmount
      });

      LoggerService.log('After update:', {
        updatedPaymentAmount: scheduledPayments.at(0).get('field_payment_amount').value
      });

      return;
    }

    // Pay In Full in edit mode: is_pay_in_full is only set by clicking the
    // radio, so it's unset when editing a saved enrollment. Don't silently
    // rewrite the saved row (it may already have payments applied). Warn
    // when its amount no longer matches the recalculated total instead.
    if (paymentsStructure === 'paid_in_full' && !this.is_pay_in_full && scheduledPayments.length === 1) {
      const subtotal = this.calcDiscountedSubtotal();
      const currentAmount = parseFloat(scheduledPayments.at(0).get('field_payment_amount')?.value) || 0;
      this.scheduledPaymentsOutOfDate = Math.abs(subtotal - currentAmount) > 0.01;
      return;
    }

    // For Installments: show warning that regeneration is needed
    if (paymentsStructure === 'installments' && this.is_use_installments) {
      // Don't show warning for MISC/Sundry categories (category 5) as they work differently
      const categoryId = this.enrollmentForm.get('field_category')?.value;
      if (categoryId === 5 || categoryId === '5') {
        return;
      }

      LoggerService.log('Setting scheduled payments out of date to TRUE');
      this.scheduledPaymentsOutOfDate = true;
    }
  }

  // Lesson total (MISC/Sundry-aware via calcLessonTotal) with the discount
  // applied: the amount a Pay In Full payment should carry, before tax.
  private calcDiscountedSubtotal(): number {
    const formValues = this.enrollmentForm.value;
    const discount = parseFloat(formValues.field_discount) || 0;
    const discountType = formValues.field_discount_type;

    let subtotal = this.calcLessonTotal();

    if (discountType === 'percentage') {
      subtotal = subtotal - (subtotal * (discount / 100));
    } else if (discountType === 'flat') {
      subtotal = subtotal - discount;
    }

    return subtotal;
  }

  // Clear the warning when payments are regenerated
  private clearScheduledPaymentsWarning() {
    LoggerService.log('Clearing scheduled payments warning');
    this.scheduledPaymentsOutOfDate = false;
  }

  // Switching Weekly/Monthly/By The Lesson invalidates any already-generated
  // plan. Clear the stale rows and flag out-of-date so the user regenerates
  // (we don't auto-generate: Weekly needs weekdays picked first, and nothing
  // can generate before lesson price/count are entered).
  onPaymentStructureTypeChange(type: string) {
    const previousType = this.enrollmentForm.get('field_payments_structure_type').value;
    this.enrollmentForm.get('field_payments_structure_type').setValue(type);

    // No-op if the type didn't actually change.
    if (previousType === type) {
      return;
    }

    const scheduledPayments = this.enrollmentForm.get('field_scheduled_payments') as FormArray;
    if (scheduledPayments.length > 0) {
      scheduledPayments.clear();
      this.scheduledPaymentsOutOfDate = true;
    }
  }

    // Temporary storage for enrollment data
  private tempEnrollmentData: any = null;

  // The enrollment this dialog has already created. Stepping Back to the
  // details step and submitting again repopulates tempEnrollmentData, so
  // without this the second save would post a second enrollment for the
  // same sale.
  private createdEnrollmentId: any = null;

  // True while a create/update request is in flight, so a double-click on
  // Save cannot fire a second request before the first one returns.
  savingEnrollment = false;

  // An Add Enrollment whose save got no response (status 0), kept in this
  // browser and offered back the next time Add Enrollment opens here.
  // enrollmentDraftExistingId is an enrollment already on file for the same
  // student around the same sale date, meaning that save may have gone through.
  enrollmentDraft: { savedAt: number, studentName: string, studentId: string, saleDate: string, values: any } = null;
  enrollmentDraftExistingId: string = null;

  // Form group for completion step - initialize immediately to avoid change detection errors
  completionFormGroup: FormGroup = this._formBuilder.group({
    completed: [false],
  });

  onSubmitEnrollment(f: NgForm, mode) {
    this.errorMessage = "";

    // Calculate instructor percentenages.
    this.fromPercentCalcTotal();

    // Calculate Pay In Full or Installments.
    if (this.is_pay_in_full) {
      this.paid_in_full();
    } else if (this.is_use_installments) {
      // this.use_installments();
    }

    this.displayProgressSpinner(true);

    let values = f.value;

    if (this.actionType == "create") {
      this.__alterValues(values);

      // Do not go on without a real student account id. A name typed without
      // picking it from the list reaches here as free text, __alterValues()
      // turns that into undefined, the request then omits field_student and
      // the enrollment is saved with no student.
      if (!values.field_student || !/^\d+$/.test(String(values.field_student))) {
        this.displayProgressSpinner(false);
        this.enrollmentForm.get('field_student')?.markAsTouched();
        this.errorMessage = "Please select a student account from the dropdown list.";
        return;
      }

            // Store data temporarily instead of creating entity immediately
      this.tempEnrollmentData = { ...values };

            // Check if student account data is already loaded (via autocomplete), otherwise load it
      if (values.field_student && !this.studentAccountEntityData) {
        // field_student might be just the ID or a formatted string, handle both cases
        let studentId = values.field_student;

        // If it's a formatted string like "Student Name (123)", extract the ID
        if (typeof studentId === 'string' && studentId.includes('(')) {
          studentId = this.regexStudentName(studentId);
        }

        LoggerService.log('Student ID for API call:', studentId);

        if (studentId && studentId !== 'undefined' && studentId !== '') {
          this._entityRESTService.getEntity('student_accounts', 'student_account', studentId)
            .subscribe(data => {
              this.studentAccountEntityData = data;
              this.loadContactData();
              this.createMockEnrollmentEntityAndProceed();
            },
            error => {
              LoggerService.error('Error loading student account data:', error);
              this.displayProgressSpinner(false);
              this.handleError(error);
            });
        } else {
          LoggerService.warn('Invalid student ID from field_student:', values.field_student);
          this.createMockEnrollmentEntityAndProceed();
        }
      } else {
        // Student data already loaded or no student selected
        let studentId = values.field_student;
        if (typeof studentId === 'string' && studentId.includes('(')) {
          studentId = this.regexStudentName(studentId);
        }
        this.createMockEnrollmentEntityAndProceed();
      }
    }

    // Edit enrollments.
    if (mode == "edit") {
      // Set field_enrollment_lesson_price to a string.
      this.__alterValues(f.value);

      this._entityRESTService.patchEntity(this.eckType, this.bundle, this.entityId, values)
        .subscribe(data => {
          this.displayProgressSpinner(false);
          // Pass the response data to confirm save completed
          this._dialogRef.close({ saved: true, data: data });
        },
          error => this.handleError(error)
        )
    }
  }

  private createMockEnrollmentEntityAndProceed(): void {
    LoggerService.log('Creating mock enrollment entity for signature step...');

    // Get raw form values first
    const formValues = { ...this.enrollmentForm.value };
    // Keep the human-readable "Package Title (id)" text for the agreement preview.
    // __alterValues() below collapses the package reference to a bare id.
    const packageNameText = formValues.field_enrollment_package_name || '';

    // Apply the same transformation that would normally happen before saving
    this.__alterValues(formValues);

    // Extract student ID from the transformed values
    const studentId = formValues.field_student;

    // Fetch student data first
    this._entityRESTService.getEntity('student_accounts', 'student_account', studentId)
      .subscribe((studentData: any) => {
        // Create comprehensive mock enrollment data with properly structured fields
        this.enrollmentEntityData = {
          id: [{ value: 'temp' }],
          title: [{ value: 'Temporary Enrollment' }],
          field_student: {
            target_id: studentId,
            title: studentData.title
          },
          field_sale_date: formValues.field_sale_date || new Date().toISOString(),
          field_category: [{ target_id: formValues.field_category }],
          field_enrollment_package_name: [{ value: packageNameText }],
          // Numeric fields that the template expects as direct values
          field_enrollment_lesson_price: this.ensureValidNumber(formValues.field_enrollment_lesson_price),
          field_enrollment_lesson_count: this.ensureValidNumber(formValues.field_enrollment_lesson_count),
          field_discount_type: formValues.field_discount_type || '',
          field_discount: this.ensureValidNumber(formValues.field_discount),
          field_tax_percentage: this.ensureValidNumber(formValues.field_tax_percentage),
          field_total_price_with_est_tax: this.ensureValidNumber(formValues.field_total_price_with_est_tax),
          field_enrollment_total_price: this.ensureValidNumber(formValues.field_enrollment_total_price),
          field_total_lessons_price: this.ensureValidNumber(formValues.field_total_lessons_price),
          field_taxes: this.ensureValidNumber(formValues.field_taxes),
          field_total_paid: this.ensureValidNumber(0),
          field_lesson_used: this.ensureValidNumber(0),
          field_lessons_paid: this.ensureValidNumber(0),
          field_lesson_available: this.ensureValidNumber(formValues.field_enrollment_lesson_count),
          field_payments_structure: formValues.field_payments_structure || 'paid_in_full',
          field_payments_structure_type: formValues.field_payments_structure_type || 'monthly',
          field_scheduled_payments: formValues.field_scheduled_payments || [],
          field_instructor_percentages: formValues.field_instructor_percentages || [],
          // Financial disclosure fields
          field_payment_amount: this.ensureValidNumber(0), // Down payment amount
          field_finance_charge: this.ensureValidNumber(0),
          field_finance_apr: this.ensureValidNumber(0),
          field_outstanding_balance_pc: this.ensureValidNumber(0),
          field_unearned_finance_charge: this.ensureValidNumber(0),
    field_early_payment_penalty: false,
    field_early_payment_refund: true,
          field_expiration_date: [{ value: formValues.field_expiration_date || '' }],
          field_executive: [{ target_id: formValues.field_executive }],
          field_notes: [{ value: formValues.field_notes || '' }],
          field_visibility: formValues.field_visibility || false,
          field_draft: formValues.field_draft || false,
          field_studio_reference: [{ target_id: this._authService.selectedStudio?.id }]
        };

        this._enrollmentEntityData = this.enrollmentEntityData;
        this.entityData = this.enrollmentEntityData;
        this.studentAccountEntityData = studentData;

        // Move to signature step using stepper navigation
        this.displayProgressSpinner(false);

        // Use setTimeout to ensure DOM is updated before calling stepper navigation
        setTimeout(() => {
          if (this.enrollmentStepper) {
            this.enrollmentStepper.next();
          } else {
            // Fallback to manual index setting if stepper ref not available
            this.enrollmentStepperIndex = 1;
            this.selectedIndex = 1;
          }
        }, 0);
      });
  }

  onSubmitPayment(f: NgForm, drop = false) {
    this.displayProgressSpinner(true);

    // Support for single or multiple enrollments.
    if (this.initActionType == "create" || this.initActionType == "refund") {
      this.errorMessage = "";

      // Copy the object to not modify binded data.
      let values = _.cloneDeep(f.value);
      this.__alterValues(values);

      if (this.initActionType == "create") {
        // Change "field_enrollment_name" to "enrollment_ids"
        values.enrollment_ids = values.field_enrollment_name;
      } else {
        // Refund
        values.enrollment_ids = [values.field_enrollment_name];
        values.field_gross_tuition = -(Math.abs(values.field_gross_tuition));
        values.field_stripe_charge_id = this.entityData?.field_stripe_charge_id;
      }

      // Support for refunds.
      if (this.initActionType == "refund") {
        this.paymentForm.value.field_gross_tuition = -(Math.abs(this.paymentForm.value.field_gross_tuition));
        this.actionType == "refund"
        // this.onSubmit(this.paymentForm);
      }

      let body = {
        ...values,
      }

      this._drupalRESTService.httpPOST('/api_rest/v1/postPayment', body).subscribe(data => {
        // Store the payment ID for receipt functionality
        if (data && data.paymentId) {
          this.latestPaymentId = data.paymentId;
        }

        this.displayProgressSpinner(false);
        this.setStepperIndex(3);
      },
        error => this.handleError(error)
      )
    } else {
      // Otherwise submit as normal to eckEntityWrapper.
      this.onSubmit(this.paymentForm);
    }
  }

  onPaymentSubmitted(paymentResponse: any) {
    if (paymentResponse.success) {
      LoggerService.log('Payment submitted successfully:', paymentResponse);
      this.dataSaved = true;

      // Store the payment ID for receipt functionality
      if (paymentResponse.paymentId) {
        this.latestPaymentId = paymentResponse.paymentId;
      }

      // Display success message
      this.showSuccessMessage('Payment processed successfully');

      // Move to the next step in the stepper
      this.setStepperIndex(3);
    } else {
      LoggerService.error('Payment submission failed:', paymentResponse.error);
      this.handlePaymentError(paymentResponse.error);
    }
  }

  /**
   * Opens the payment receipt dialog for the latest payment
   */
  openReceiptDialog(): void {
    if (!this.latestPaymentId) {
      this._snackBar.open('No payment receipt available', 'Close', {
        duration: 3000,
      });
      return;
    }

    this._dialog.open(PaymentReceiptComponent, {
      width: '800px',
      height: '800px',
      data: { paymentId: this.latestPaymentId },
      panelClass: 'receipt-dialog',
      disableClose: false
    });
  }

  private determinePaymentStatus(paidAmount: number): string {
    const totalDue = parseFloat(this.enrollmentEntityData.field_total_price_with_est_tax);
    const totalPaid = parseFloat(this.enrollmentEntityData.field_total_paid) + paidAmount;

    if (totalPaid >= totalDue) {
      return 'Paid in Full';
    } else if (totalPaid > 0) {
      return 'Partially Paid';
    } else {
      return 'Unpaid';
    }
  }

  private showSuccessMessage(message: string) {
    // Implement your preferred method of showing success messages
    // For example, using Angular Material's MatSnackBar:
    this._snackBar.open(message, 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private handlePaymentError(error: any) {
    // Implement your error handling logic
    // For example, showing an error message to the user
    this._snackBar.open('Payment failed: ' + error.message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });

    // Optionally, you might want to reset the payment form or take other actions
  }

  private isLastStep(): boolean {
    // Implement logic to determine if this is the last step in your enrollment process
    return this.enrollmentStepper.selectedIndex === this.enrollmentStepper.steps.length - 1;
  }

  private handleEnrollmentFinalizationError(error: any) {
    // Handle errors that occur during enrollment finalization
    this._snackBar.open('Error finalizing enrollment: ' + error.message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['error-snackbar']
    });
  }

  calcScheduledPayments() {
    // Without a structure type the branches below generate nothing but the
    // clear() still wipes existing rows. Bail out with feedback instead.
    const selectedStructureType = this.enrollmentForm.get('field_payments_structure_type').value;
    if (selectedStructureType != 'monthly' && selectedStructureType != 'weekly' && selectedStructureType != 'by_the_lesson') {
      this._snackBar.open('Choose Weekly, Monthly, or By The Lesson before generating the payment plan.', 'Close', {
        duration: 5000,
      });
      return;
    }

    // Clear the out-of-date warning when regenerating payments
    this.clearScheduledPaymentsWarning();

    // Set flag to prevent checkScheduledPaymentsValidity from running during generation
    this.isGeneratingPayments = true;

    this.enrollmentForm.get('interval').value;
    this.enrollmentForm.get('field_payments_structure').value;

    let interval = this.enrollmentForm.get('interval').value;
    let startIntervalDate = moment();

    let totalPayments = this.calcNewTotal();

    // Optional down payment / initial investment. For tax-on-top studios the
    // staff types the amount the customer actually hands over (INCL. tax) and
    // the pre-tax part is backed out exactly, mirroring the per-row Total
    // column ($380 at 13% → $336.28 + $43.72 tax = $380.00 on the row).
    // Inclusive-tax and untaxed studios use the figure as-is. The pre-tax
    // part becomes the first scheduled-payment row and the REMAINDER is split
    // into the installments, so the rows still sum to the total. Clamped to
    // [0, total].
    const downPaymentEntered = Math.round((parseFloat(this.enrollmentForm.get('field_down_payment_amount')?.value) || 0) * 100) / 100;
    let downPayment = downPaymentEntered;
    // Exact split tax for the DP row; null when the fallback per-row estimate
    // applies (pre-tax entry modes, or the clamp below changed the gross).
    let downPaymentSplitTax: number | null = null;
    if (downPaymentEntered > 0 && this.scheduledRowsShowTotal) {
      const split = this.splitInclusiveTotal(downPaymentEntered);
      downPayment = split.gross;
      downPaymentSplitTax = split.tax;
    }
    const downPaymentBeforeClamp = downPayment;
    downPayment = Math.min(Math.max(downPayment, 0), totalPayments);
    // Round to cents so the DP row (stored as .toFixed(2)) and the remainder split
    // stay consistent. Otherwise a >2-decimal entry makes the rows fail the
    // backend "sum of payments == total" check.
    downPayment = Math.round(downPayment * 100) / 100;
    if (downPayment !== downPaymentBeforeClamp) {
      downPaymentSplitTax = null;
    }
    let amountToInstall = totalPayments - downPayment;

    // Split by an agreed per-payment amount instead of a count: every
    // installment is that amount and the last one is whatever is left
    // ($5,000 at $1,200 → 4 × $1,200 + $200). Tax-on-top studios enter the
    // amount INCL. tax, as the student agreed to it, so the pre-tax part is
    // backed out the same way as the down payment and each full row's tax is
    // the exact complement, keeping its Total at the agreed figure.
    let fixedRowGross: number | null = null;
    let fixedRowTax: number | null = null;
    const splitByAmount = this.enrollmentForm.get('installment_split_mode')?.value === 'amount'
      && (this.enrollmentForm.get('field_payments_structure_type').value == 'monthly' || this.enrollmentForm.get('field_payments_structure_type').value == 'weekly');
    if (splitByAmount) {
      const agreed = Math.round((parseFloat(this.enrollmentForm.get('installment_amount')?.value) || 0) * 100) / 100;
      if (!(agreed > 0)) {
        this._snackBar.open('Enter the payment amount to split the total into.', 'Close', { duration: 4000 });
        this.isGeneratingPayments = false;
        return;
      }
      fixedRowGross = agreed;
      if (this.scheduledRowsShowTotal) {
        const split = this.splitInclusiveTotal(agreed);
        fixedRowGross = split.gross;
        fixedRowTax = split.tax;
      }
      const remainderCents = Math.round(amountToInstall * 100);
      const rowCents = Math.round(fixedRowGross * 100);
      interval = rowCents >= remainderCents || rowCents <= 0 ? 1 : Math.ceil(remainderCents / rowCents);
      if (interval > 120) {
        this._snackBar.open('That payment amount would create more than 120 payments. Enter a larger amount.', 'Close', { duration: 5000 });
        this.isGeneratingPayments = false;
        return;
      }
    }

    let totalPaymentsDivideByInterval = amountToInstall / interval;

    // The start date.
    let newGeneratedDate = moment(this.enrollmentForm.get('field_recurrent_month_day').value, 'YYYY-MM-DD');

    // If no start date is selected, default to today
    if (!this.enrollmentForm.get('field_recurrent_month_day').value) {
      const todayDate = moment().format('YYYY-MM-DD'); // Use full date format for the form control
      this.enrollmentForm.patchValue({
        field_recurrent_month_day: todayDate
      });
    }

    (<FormArray>this.enrollmentForm.get('field_scheduled_payments')).clear();

    // Down payment is the first row, due on the schedule start date. Subsequent
    // installments split the remainder. Monthly/weekly only. The by-the-lesson
    // branch below splits proportionally by lesson and re-clears this array.
    const structureType = this.enrollmentForm.get('field_payments_structure_type').value;
    const supportsDownPayment = structureType == 'monthly' || structureType == 'weekly';
    const hasDownPaymentRow = downPayment > 0 && supportsDownPayment;
    if (hasDownPaymentRow) {
      const dpDate = moment(this.enrollmentForm.get('field_recurrent_month_day').value, 'YYYY-MM-DD');
      this.scheduledPaymentIncrement({
        'id': [null],
        'field_amount_paid': [null],
        'field_enrollment': [null],
        'field_paid_in_full': [false],
        'field_down_payment': [true, Validators.required],
        'field_payment_amount': [downPayment.toFixed(2), Validators.required],
        'field_tax_amount': [downPaymentSplitTax ?? this.calculateEstimatedTax(downPayment)],
        'field_payment_date': [dpDate.format('YYYY-MM-DD'), Validators.required],
        'field_number_lesson_remaining': [null],
        'field_studio_reference': [this._authService.selectedStudio?.id],
        'bundle': ['scheduled_payments', Validators.required],
        'type': ['scheduled_payments', Validators.required],
      });

      // Down payment covers the full total. No remainder to split.
      if (amountToInstall <= 0) {
        this.isGeneratingPayments = false;
        return;
      }
    }

    let roundedPaymentAmount = Math.floor(totalPaymentsDivideByInterval * 100) / 100;

    // Equal cent installments with the LAST one absorbing the split remainder.
    // The remainder used to land on the FIRST payment, which made it a penny
    // larger than the quoted per-payment figure. Customers paid the round
    // amount and a 1¢ "Payment Due" residue stuck to the schedule forever.
    let installmentsIssued = 0;
    const perInstallment = fixedRowGross ?? roundedPaymentAmount;
    // Tax for the installment just drawn: the exact complement of an agreed
    // incl.-tax amount on full rows, the estimate everywhere else.
    let lastDrawnTax = 0;
    const nextInstallmentAmount = (): string => {
      const isLast = installmentsIssued === interval - 1;
      const amount = isLast
        ? amountToInstall - perInstallment * (interval - 1)
        : perInstallment;
      installmentsIssued++;
      const fixed = (Math.round(amount * 100) / 100).toFixed(2);
      lastDrawnTax = (!isLast && fixedRowTax !== null) ? fixedRowTax : this.calculateEstimatedTax(parseFloat(fixed));
      return fixed;
    };

    // When a down payment occupies the start date, push the installments out one
    // period so the first installment doesn't collide with the down-payment date.
    if (hasDownPaymentRow) {
      newGeneratedDate.add(1, structureType == 'weekly' ? 'weeks' : 'months');
    }

    let i;
    let o = hasDownPaymentRow ? 1 : 0;

    if (this.enrollmentForm.get('field_payments_structure_type').value == 'monthly' || this.enrollmentForm.get('field_payments_structure_type').value == 'weekly') {

      // Pre-validate for weekly payments before entering the loop
      if (this.enrollmentForm.get('field_payments_structure_type').value == 'weekly') {
        let weekdays = [];
        if (this.enrollmentForm.get('field_recurrent_weekday_su').value) { weekdays.push(0); }
        if (this.enrollmentForm.get('field_recurrent_weekday_mo').value) { weekdays.push(1); }
        if (this.enrollmentForm.get('field_recurrent_weekday_tu').value) { weekdays.push(2); }
        if (this.enrollmentForm.get('field_recurrent_weekday_we').value) { weekdays.push(3); }
        if (this.enrollmentForm.get('field_recurrent_weekday_th').value) { weekdays.push(4); }
        if (this.enrollmentForm.get('field_recurrent_weekday_fr').value) { weekdays.push(5); }
        if (this.enrollmentForm.get('field_recurrent_weekday_sa').value) { weekdays.push(6); }

        // Validation: At least one weekday must be selected
        if (weekdays.length == 0) {
          this._snackBar.open('Please select at least one day of the week for weekly payments', 'Close', {
            duration: 3000,
          });
          return;
        }

        // Validation: Interval must be valid
        if (!interval || interval <= 0) {
          this._snackBar.open('Please enter a valid number of payments greater than 0', 'Close', {
            duration: 3000,
          });
          return;
        }

        // Validation: Total payments must be valid
        if (!totalPayments || totalPayments <= 0) {
          this._snackBar.open('Please ensure the enrollment has a valid total amount', 'Close', {
            duration: 3000,
          });
          return;
        }

        // Validation: Start date must be valid
        if (!newGeneratedDate.isValid()) {
          this._snackBar.open('Please select a valid start date for payments', 'Close', {
            duration: 3000,
          });
          return;
        }
      }

      for (i = 0; i < interval; i++) {
        let paymentAmount = nextInstallmentAmount();
        let taxAmount = lastDrawnTax;

        if (this.enrollmentForm.get('field_payments_structure_type').value == 'monthly') {
          newGeneratedDate = moment(this.enrollmentForm.get('field_recurrent_month_day').value, 'YYYY-MM-DD').add(o, 'months');

          let controlsConfig = {
            'id': [null],
            'field_amount_paid': [null],
            'field_enrollment': [null],
            'field_paid_in_full': [false],
            'field_down_payment': [false, Validators.required],
            'field_payment_amount': [paymentAmount, Validators.required],
            'field_tax_amount': [taxAmount],
            'field_payment_date': [newGeneratedDate.format('YYYY-MM-DD'), Validators.required],
            'field_number_lesson_remaining': [null],
            'field_studio_reference': [this._authService.selectedStudio?.id],
            'bundle': ['scheduled_payments', Validators.required],
            'type': ['scheduled_payments', Validators.required],
          };

          this.scheduledPaymentIncrement(controlsConfig);

          // Check for steps payment_builder_date_step
          this.enrollmentForm.get('payment_builder_date_step').value.forEach(element => {
            i = i + 1;
            // Don't allow more than the interval.
            if (i < interval) {
              let newGeneratedDateInterval = moment(newGeneratedDate).set("date", element.field_recurrent_month_day);
              // Each step row is its own installment. Draw its own amount so
              // the last-row remainder lands on the true final row.
              const stepAmount = nextInstallmentAmount();
              const stepTax = lastDrawnTax;

              let controlsConfig = {
                'id': [null],
                'field_amount_paid': [null],
                'field_enrollment': [null],
                'field_paid_in_full': [false],
                'field_down_payment': [false, Validators.required],
                'field_payment_amount': [stepAmount, Validators.required],
                'field_tax_amount': [stepTax],
                'field_payment_date': [newGeneratedDateInterval.format('YYYY-MM-DD'), Validators.required],
                'field_number_lesson_remaining': [null],
                'field_studio_reference': [this._authService.selectedStudio?.id],
                'bundle': ['scheduled_payments', Validators.required],
                'type': ['scheduled_payments', Validators.required],
              };

              this.scheduledPaymentIncrement(controlsConfig);
            }
          });

          o++;
        }

        if (this.enrollmentForm.get('field_payments_structure_type').value == 'weekly') {
          // Get weekdays for payment scheduling (validation already done above)
          let weekdays = [];
          if (this.enrollmentForm.get('field_recurrent_weekday_su').value) { weekdays.push(0); }
          if (this.enrollmentForm.get('field_recurrent_weekday_mo').value) { weekdays.push(1); }
          if (this.enrollmentForm.get('field_recurrent_weekday_tu').value) { weekdays.push(2); }
          if (this.enrollmentForm.get('field_recurrent_weekday_we').value) { weekdays.push(3); }
          if (this.enrollmentForm.get('field_recurrent_weekday_th').value) { weekdays.push(4); }
          if (this.enrollmentForm.get('field_recurrent_weekday_fr').value) { weekdays.push(5); }
          if (this.enrollmentForm.get('field_recurrent_weekday_sa').value) { weekdays.push(6); }

          while (!weekdays.includes(newGeneratedDate.day())) {
            newGeneratedDate.add(1, 'day');
          }

          let controlsConfig = {
            'id': [null],
            'field_amount_paid': [null],
            'field_enrollment': [null],
            'field_paid_in_full': [false],
            'field_down_payment': [false, Validators.required],
            'field_payment_amount': [paymentAmount, Validators.required],
            'field_tax_amount': [taxAmount],
            'field_payment_date': [newGeneratedDate.format('YYYY-MM-DD'), Validators.required],
            'field_number_lesson_remaining': [null],
            'field_studio_reference': [this._authService.selectedStudio?.id],
            'bundle': ['scheduled_payments', Validators.required],
            'type': ['scheduled_payments', Validators.required],
          };

          this.scheduledPaymentIncrement(controlsConfig);

          let added = false;
          while (!added) {
            newGeneratedDate.add(1, 'day');
            if (weekdays.includes(newGeneratedDate.day())) {
              added = true;
            }
          }
        }
      }
    }

    if (this.enrollmentForm.get('field_payments_structure_type').value === 'by_the_lesson') {
      const interval = this.enrollmentForm.get('interval').value;  // # of lessons per payment
      const totalLessons = this.enrollmentForm.get('field_enrollment_lesson_count').value;
      const totalPrice = this.calcNewTotal();

      // For MISC/Sundry (totalLessons = 0), treat as single payment
      if (totalLessons === 0) {
        const taxAmount = this.calculateEstimatedTax(totalPrice);
        const paymentDate = moment(this.enrollmentForm.get('field_recurrent_month_day').value).format('YYYY-MM-DD');

        const controlsConfig = {
          id: [null],
          field_amount_paid: [null],
          field_enrollment: [null],
          field_paid_in_full: [false],
          field_down_payment: [true, Validators.required],
          field_payment_amount: [totalPrice.toFixed(2), Validators.required],
          field_tax_amount: [taxAmount],
          field_payment_date: [paymentDate, Validators.required],
          field_number_lesson_remaining: [0],
          field_studio_reference: [this._authService.selectedStudio?.id],
          bundle: ['scheduled_payments', Validators.required],
          type: ['scheduled_payments', Validators.required],
        };

        this.scheduledPaymentIncrement(controlsConfig);
        return;
      }

      // How many installments in total
      const totalInstallments = Math.ceil(totalLessons / interval);

      // Price per lesson
      const pricePerLesson = totalPrice / totalLessons;

      // Clear out old scheduled payments
      (this.enrollmentForm.get('field_scheduled_payments') as FormArray).clear();

      // Track lessons covered so far
      let lessonsCovered = 0;
      // Rows are rounded to cents individually; the LAST row takes whatever
      // remains so the rows always sum exactly to the total (matching the
      // backend's sum-of-rows check, and keeping the odd penny off the rows
      // customers pay first).
      let amountRemaining = Math.round(totalPrice * 100) / 100;

      for (let i = 0; i < totalInstallments; i++) {
        // Calculate how many lessons this payment covers
        const lessonsInThisPayment = Math.min(interval, totalLessons - lessonsCovered);

        // Calculate payment amount based on lessons in this payment
        const paymentAmount = lessonsInThisPayment * pricePerLesson;
        // Round to 2 decimals
        const roundedPaymentAmount = i === totalInstallments - 1
          ? Math.round(amountRemaining * 100) / 100
          : Math.round(paymentAmount * 100) / 100;
        amountRemaining = Math.round((amountRemaining - roundedPaymentAmount) * 100) / 100;

        // Tax calculation (if applicable)
        const taxAmount = this.calculateEstimatedTax(roundedPaymentAmount);

        // Get payment date - first payment is on the selected date, others are null (to be filled by user)
        const paymentDate = i === 0
          ? moment(this.enrollmentForm.get('field_recurrent_month_day').value).format('YYYY-MM-DD')
          : null;

        // Calculate lessons remaining BEFORE this payment
        // This shows a countdown from total lessons
        const lessonsRemainingDisplay = totalLessons - lessonsCovered;

        // Configure form controls
        const controlsConfig = {
          id: [null],
          field_amount_paid: [null],
          field_enrollment: [null],
          field_paid_in_full: [false],
          field_down_payment: [i === 0, Validators.required], // First payment is down payment
          field_payment_amount: [roundedPaymentAmount.toFixed(2), Validators.required],
          field_tax_amount: [taxAmount],
          field_payment_date: [paymentDate, i === 0 ? Validators.required : null], // Only require date for first payment
          // Store lesson count as countdown - "Due at lesson X"
          field_number_lesson_remaining: [lessonsRemainingDisplay],
          field_studio_reference: [this._authService.selectedStudio?.id],
          bundle: ['scheduled_payments', Validators.required],
          type: ['scheduled_payments', Validators.required],
        };

        // Add this installment to the form array
        this.scheduledPaymentIncrement(controlsConfig);

        // Update lessons covered for next iteration
        lessonsCovered += lessonsInThisPayment;
      }
    }

    this.reconcileScheduledTaxRemainder();

    // Clear the flag after payment generation is complete
    this.isGeneratingPayments = false;
  }

  /**
   * Each scheduled row's estimated tax is rounded to cents independently, so
   * across many installments the rows can drift a few cents from tax-on-the-total
   * (what field_taxes stores). Fold the difference into the LAST row (the row
   * that already absorbs the payment-amount remainder) so the schedule's tax
   * column sums to the enrollment's tax while the rows customers pay first
   * keep the quoted figures. Drift beyond what rounding alone can produce
   * (half a cent per row) is left visible rather than papered over.
   */
  private reconcileScheduledTaxRemainder() {
    const rows = this.enrollmentForm.get('field_scheduled_payments') as FormArray;
    if (!rows || rows.length < 2) {
      return;
    }

    const preTaxTotal = rows.controls.reduce((sum, row) =>
      sum + (parseFloat(row.get('field_payment_amount')?.value) || 0), 0);
    const totalTax = this.calculateEstimatedTax(this.roundNumber(preTaxTotal, 2));
    const rowTaxSum = rows.controls.reduce((sum, row) =>
      sum + (parseFloat(row.get('field_tax_amount')?.value) || 0), 0);

    const drift = this.roundNumber(totalTax - rowTaxSum, 2);
    if (drift === 0 || Math.abs(drift) > rows.length * 0.005 + 0.01) {
      return;
    }

    const lastRow = rows.at(rows.length - 1);
    const lastRowTax = parseFloat(lastRow.get('field_tax_amount')?.value) || 0;
    lastRow.patchValue({ field_tax_amount: this.roundNumber(lastRowTax + drift, 2) });
  }


  scheduledPaymentIncrement(controlsConfig?) {
    let control = this._formBuilder.group(controlsConfig ?? {
      'id': [null],
      'field_amount_paid': [null],
      'field_enrollment': [null],
      'field_paid_in_full': [false],
      'field_down_payment': [false, Validators.required],
      'field_payment_amount': [null, Validators.required],
      'field_tax_amount': [null],
      'field_payment_date': [null, Validators.required],
      'field_number_lesson_remaining': [null],
      'field_studio_reference': [this._authService.selectedStudio?.id],
      'bundle': ['scheduled_payments', Validators.required],
      'type': ['scheduled_payments', Validators.required],
    });

    (<FormArray>this.enrollmentForm.get('field_scheduled_payments')).push(control)
  }

  /**
   * Human label for a scheduled-payment row. The down-payment row (always first
   * when present) is called out separately; remaining rows are numbered as
   * installments independently of the down payment ("Payment 1 of 5").
   */
  scheduledPaymentLabel(index: number): string {
    const payments = this.enrollmentForm.get('field_scheduled_payments') as FormArray;
    const row = payments.at(index);

    // Pay In Full produces a single row flagged both paid-in-full and down-payment;
    // it's the whole payment, not an initial investment.
    if (this.enrollmentForm.get('field_payments_structure')?.value === 'paid_in_full') {
      return 'Payment in Full';
    }

    if (row?.get('field_down_payment')?.value === true) {
      return 'Down Payment / Initial Investment';
    }

    const hasDownPayment = payments.at(0)?.get('field_down_payment')?.value === true;
    const installmentNumber = hasDownPayment ? index : index + 1;
    const installmentTotal = hasDownPayment ? payments.length - 1 : payments.length;
    return `Payment ${installmentNumber} of ${installmentTotal}`;
  }

  scheduledPaymentRemove(index: number) {
    (<FormArray>this.enrollmentForm.get('field_scheduled_payments')).removeAt(index)
  }

  public instructorPercentageIncrement() {
    const instructors = this.enrollmentForm.get('field_instructor_percentages') as FormArray;

    const control = this._formBuilder.group({
      id: [null],
      field_amount: [null, Validators.required],
      // field_enrollment: [null, Validators.required],
      field_instructor: [null, Validators.required],
      field_percentage: [instructors.length === 0 ? 100 : 0, Validators.required],
      field_studio_reference: [this._authService.selectedStudio?.id],
      bundle: ['instructor_percentages', Validators.required],
      type: ['instructor_percentages', Validators.required],
    });

    instructors.push(control);
    this.rebalanceInstructorPercentagesEqualSplit();
    this.fromPercentCalcTotal();
  }

  validationErrors = [];

  instructorPercentageRemove(index: number) {
    (<FormArray>this.enrollmentForm.get('field_instructor_percentages')).removeAt(index);
    this.rebalanceInstructorPercentagesEqualSplit();
    this.fromPercentCalcTotal();
  }

  resetInstructorFormGroup() {
    this.enrollmentMessage = "";
    this.autoCompleteStudentContactOptions = null;
    this.enrollmentsForUser = null;
    this.enrollmentForm.controls['__field_students_inline_form'].reset();
  }

  onPackageLookup($event: { option: { value: any; }; }) {

    this._entityRESTService.getEntity('packages', 'package', this.regexParamID($event.option.value))
      .subscribe(response => {
        const categoryValue = this.mapSpsCodeToCategory(response['field_sps_code']);

        this.enrollmentForm.patchValue({
          field_enrollment_total_price: response['field_total_price'],
          field_enrollment_lesson_price: response['field_lesson_price'],
          field_enrollment_lesson_count: response['field_lesson_count'],
          field_discount: response['field_discount'] || 0,
          field_discount_type: response['field_discount_type'] || 'flat',
          field_category: categoryValue,
        });

        this.calcNewTotal();
      })

  }

  private mapSpsCodeToCategory(spsCode: string): string {
    // Maps SPS code taxonomy term IDs to enrollment_type category term IDs
    const mapping: { [key: string]: string } = {
      '1394': '1395',  // DE -> DE
      '550': '51',     // EXT -> Extension
      '554': '5',      // MISC -> Miscellaneous
      '657': '66',     // Non Unit -> Non-Unit
      '549': '50',     // ORI -> Original
      '547': '49',     // PORI -> Pre-Original
      '552': '65',     // REN -> Renewals
      '558': '67',     // SUNDRY -> Sundry
    };
    return mapping[spsCode] || '70'; // Default to Uncategorized
  }

  paid_in_full() {
    this.is_pay_in_full = true;
    this.is_use_installments = false;
    // Clear warning when switching to pay in full
    this.clearScheduledPaymentsWarning();

    // Explicitly set the form control value
    this.enrollmentForm.patchValue({
      field_payments_structure: 'paid_in_full'
    });

    const scheduledPayments = <FormArray>this.enrollmentForm.get('field_scheduled_payments');

    // When editing, the first row is a saved scheduled_payments entity. Carry
    // its identity into the rebuilt row so Save updates it in place instead of
    // posting a replacement with a null id and orphaning the original.
    const existingRow = scheduledPayments.length > 0 ? scheduledPayments.at(0).value : null;

    // Clear the current form.
    scheduledPayments.clear();

    // Calculate data needed.
    LoggerService.log('field_enrollment_total_price', this.enrollmentForm.get('field_enrollment_total_price').value, this.calculateEstimatedTax(this.enrollmentForm.get('field_enrollment_total_price').value));
    // Add the newly calculated data.
    let control = this._formBuilder.group({
      'id': [existingRow?.id ?? null],
      'field_amount_paid': [existingRow?.field_amount_paid ?? null],
      'field_enrollment': [existingRow?.field_enrollment ?? null],
      'field_paid_in_full': [true],
      'field_down_payment': [true, Validators.required],
      'field_payment_amount': [this.enrollmentForm.get('field_enrollment_total_price').value, Validators.required],
      'field_tax_amount': [this.calculateEstimatedTax(this.enrollmentForm.get('field_enrollment_total_price').value)],
      'field_payment_date': [existingRow?.field_payment_date ?? this.enrollmentForm.get('field_sale_date').value ?? moment().format('YYYY-MM-DD'), Validators.required],
      'field_scheduled_payments': [null],
      'field_number_lesson_remaining': [existingRow?.field_number_lesson_remaining ?? null],
      'field_studio_reference': [existingRow?.field_studio_reference ?? this._authService.selectedStudio?.id],
      'bundle': ['scheduled_payments', Validators.required],
      'type': ['scheduled_payments', Validators.required],
    });

    scheduledPayments.push(control);
  }

  use_installments() {
    this.is_use_installments = true;
    this.is_pay_in_full = false;
    // Clear warning when switching to installments (new plan will be generated)
    this.clearScheduledPaymentsWarning();

    // Explicitly set the form control value
    this.enrollmentForm.patchValue({
      field_payments_structure: 'installments'
    });

    // Clear the current form.
    (<FormArray>this.enrollmentForm.get('field_scheduled_payments')).clear();

    // Add the newly calculated data.
    let control = this._formBuilder.group({
      'id': [null],
      'field_amount_paid': [null],
      'field_enrollment': [null],
      'field_paid_in_full': [false],
      'field_down_payment': [false, Validators.required],
      'field_payment_amount': [null, Validators.required],
      'field_tax_amount': [null],
      'field_payment_date': [null, Validators.required],
      'field_scheduled_payments': [null],
      'field_number_lesson_remaining': [null],
      'field_studio_reference': [this._authService.selectedStudio?.id],
      'bundle': ['scheduled_payments', Validators.required],
      'type': ['scheduled_payments', Validators.required],
    });

    (<FormArray>this.enrollmentForm.get('field_scheduled_payments')).push(control);
  }

  paymentPlanGeneratorIncreaseStep() {
    // Add the newly calculated data.
    let control = this._formBuilder.group({
      field_recurrent_month_day: 'first',
    });

    (<FormArray>this.enrollmentForm.get('payment_builder_date_step')).push(control);
  }

  paymentPlanGeneratorRemoveStep(index) {
    (<FormArray>this.enrollmentForm.get('payment_builder_date_step')).removeAt(index)
  }

  calcDiscount() {
    let formValues = this.enrollmentForm.value;

    // Initialize discountTotal as a number.
    this.discountTotal = 0;

    // Calculate a percentage discount.
    if (formValues.field_discount_type == 'percentage') {
      this.discountTotal = (
        (parseFloat(formValues.field_enrollment_lesson_price) * parseFloat(formValues.field_enrollment_lesson_count)) *
        (parseFloat(formValues.field_discount) / 100)
      ) || 0;
    }

    // Flat discounts. The backend (amt_enrollment_calcDiscount) treats every
    // non-percentage type — including the EMPTY type on imported/older
    // enrollments — as flat, so mirror it. Requiring type == 'flat' here made
    // an edit-mode load compute totals without the discount ($600-based
    // $689.85 instead of the stored 460-based $528.89) and raise a false
    // "payments out of date" warning.
    else {
      this.discountTotal = parseFloat(formValues.field_discount) || 0;
    }

    // Ensuring discountTotal is a number before calling toFixed
    let discountTotalRounded = parseFloat(this.discountTotal).toFixed(2);

    // Since discountTotalRounded is a string, it can be directly assigned
    this.displayDiscountTotalString = discountTotalRounded;

    // Returning the number version of the rounded discount for any further calculations
    return parseFloat(discountTotalRounded);
  }

  calcLessonTotal() {
    let formValues = this.enrollmentForm.value;

    // If non-unit (66) is 0, return 0.
    if (formValues.field_category == '66' && formValues.field_enrollment_lesson_count == 0) {
      return (formValues.field_enrollment_lesson_price);
    }

    // If the category is misc (5) or sundry (67), return the lesson price.
    if (formValues.field_category == '5' || formValues.field_category == '67') {
      // Update whatever lesson count is to 0
      this.enrollmentForm.patchValue({
        field_enrollment_lesson_count: 0,
      });

      return (formValues.field_enrollment_lesson_price);
    } else {
      return (formValues.field_enrollment_lesson_price * formValues.field_enrollment_lesson_count);
    }
  }

  calcTotalWithDiscount() {
    let formValues = this.enrollmentForm.value;
    return this.calcLessonTotal() - this.calcDiscount();
  }

  calcTotalWithTaxes(totalBeforeTaxes: number) {
    this.taxRate = this.enrollmentForm.get("field_tax_percentage").value ?? 0;
    // Inclusive taxes are already inside the price; only the exclusive part
    // (each tax rounded by its own configured rule) is added on top.
    return totalBeforeTaxes + this.computeTaxParts(Number(totalBeforeTaxes)).exclusive;
  }

  /**
   *
   * @returns The total before taxes.
   */
  calcNewTotal() {
    LoggerService.log('calcNewTotal');
    let formValues = this.enrollmentForm.value;
    let total;
    let totalBeforeTaxes;
    let lessonPriceTotal;

    // Tax, Discount, and Gift Certificate calculations. The pre-tax base is
    // rounded to cents first so the tax, the grand total and the stored fields
    // all derive from the same cent-exact amount.
    lessonPriceTotal = this.calcLessonTotal();
    totalBeforeTaxes = this.calcTotalWithDiscount();

    lessonPriceTotal = Number.parseFloat(lessonPriceTotal).toFixed(2);
    totalBeforeTaxes = Number.parseFloat(totalBeforeTaxes).toFixed(2);
    total = this.calcTotalWithTaxes(Number(totalBeforeTaxes)).toFixed(2);

    // Check for non real numbers.
    if (isNaN(totalBeforeTaxes) || isNaN(total)) {
    } else {
      LoggerService.log('total', total);

      // Exclusive + inclusive tax dollars, each configured tax rounded by its
      // own rule (see computeTaxParts).
      const taxParts = this.computeTaxParts(Number(totalBeforeTaxes));
      const taxAmount = taxParts.exclusive + taxParts.inclusive;

      this.enrollmentForm.patchValue({
        field_enrollment_total_price: totalBeforeTaxes,
        field_total_lessons_price: lessonPriceTotal,
        field_total_price_with_est_tax: total,
        field_taxes: this.roundNumber(taxAmount, 2)
      });
    }

    // Determine if enrollment is misc or sundry item.
    this.isMiscOrSundry = (formValues.field_category == 5 || formValues.field_category == 67) ?? false;

    // Balance limit: Check if total exceeds the balance limit of $20,000.
    // Compared PRE-TAX: the server's remaining_amount is built from pre-tax
    // balances (field_balance_due, field_enrollment_total_price), so the new
    // enrollment must count against it pre-tax too. Otherwise exclusive-tax
    // studios lose budget to tax that never counts toward the cap.
    // If the enrollment is MISC, SUNDRY, or non-unit (66), then do not check the balance limit.
    if (this.studentBalanceData && parseFloat(totalBeforeTaxes) > parseFloat(this.studentBalanceData?.remaining_amount) && !this.isMiscOrSundry && formValues.field_category != 66) {
      this.studentBalanceWarning = 'Total exceeds the balance limit of $20,000.' + ' Remaining: $' + this.studentBalanceData?.remaining_amount;
      return;
    } else {
      this.studentBalanceWarning = null;
    }

    // Calculate instructor percentage when total update.
    this.fromPercentCalcTotal();

    // Validate DE category price
    this.validateDECategoryPrice();

    return totalBeforeTaxes;
  }

  validateDECategoryPrice() {
    const formValues = this.enrollmentForm.value;
    LoggerService.log('Validating DE category price', formValues.field_category, formValues.field_enrollment_lesson_price);
    if (formValues.field_category == '1395' && parseFloat(formValues.field_enrollment_lesson_price) > 0) {
      this.deCategoryPriceWarning = 'For DE category, the lesson price must be 0.';
      LoggerService.log('DE category price warning set', this.deCategoryPriceWarning);
    } else {
      this.deCategoryPriceWarning = null;
    }
  }

  fromPercentCalcTotal() {
    const formValues = this?.enrollmentForm?.value;
    const total = this.calcTotalWithDiscount();
    const instructors = this.enrollmentForm.get('field_instructor_percentages') as FormArray;

    if (formValues?.field_instructor_percentages && instructors?.length) {
      formValues.field_instructor_percentages.forEach((values, idx) => {
        const percentage = Number(values.field_percentage) || 0;
        const amount = (percentage / 100) * total;

        instructors.at(idx).patchValue({
          field_amount: Number.parseFloat(amount.toFixed(2))
        }, { emitEvent: false });
      });
    }
  }

  private rebalanceInstructorPercentagesEqualSplit() {
    const instructors = this.enrollmentForm.get('field_instructor_percentages') as FormArray;
    const count = instructors?.length ?? 0;
    if (!count) {
      return;
    }

    const equalShare = Number((100 / count).toFixed(2));
    let remaining = 100;

    instructors.controls.forEach((control, index) => {
      const percentage = (index === count - 1) ? Number(remaining.toFixed(2)) : equalShare;
      remaining -= equalShare;
      control.patchValue({ field_percentage: percentage }, { emitEvent: false });
    });
  }

  updateCount($count) {
    this.eventCount = $count;
  }

  // Note: This method is called by the directive when the sale date changes
  // We need to subscribe to field_sale_date value changes to auto-set expiration date
  // Track whether any data was saved during this dialog's lifecycle
  dataSaved = false;

  override closeDialog(data?) {
    // If data already has saved flag, use it. Otherwise, use tracked state.
    if (data?.saved || this.dataSaved) {
      super.closeDialog({ saved: true, ...(data || {}) });
    } else {
      super.closeDialog(data);
    }
  }

  override setFormValues(formRef = null) {
    super.setFormValues(formRef);
    // Decimal fields come back at storage scale ("14.000"); show the number
    // in the Taxes % input.
    const rate = this.enrollmentForm?.get('field_tax_percentage')?.value;
    if (typeof rate === 'string' && rate !== '' && !isNaN(parseFloat(rate))) {
      this.enrollmentForm.patchValue({ field_tax_percentage: parseFloat(rate) }, { emitEvent: false });
    }
    this.restoreInstallmentBuilderInputs();
    this.restoreDownPaymentInput();
    // The stored field_total_price_with_est_tax is PRE-tax (the backend
    // presave overwrites it with the pre-tax total), so a loaded enrollment
    // shows Total Investment without tax. Recompute from the loaded values.
    // The backend re-derives all of these on every save, so this introduces
    // nothing a save wouldn't.
    this.calcNewTotal();
  }

  // The installment builder's interval and start date are UI-only controls
  // (the enrollment entity has no fields for them), so an edit-mode load left
  // them at their defaults (1 / blank) even though the saved rows reflect the
  // chosen plan. Derive them back from the loaded scheduled-payment rows, the
  // same way the down-payment input is back-filled. Runs after the base load
  // so the rows and the (sanitized) structure type are already patched.
  private restoreInstallmentBuilderInputs(): void {
    if (this.enrollmentForm?.get('field_payments_structure')?.value !== 'installments') { return; }
    const structureType = this.enrollmentForm.get('field_payments_structure_type')?.value;
    const rows = (this.enrollmentForm.get('field_scheduled_payments') as FormArray)?.controls;
    if (!rows?.length) { return; }

    // The generator stamps the entered start date on the schedule's first row
    // for every structure type (the down-payment row when present, else the
    // first installment). Later by-the-lesson rows can hold null dates, so take
    // the earliest non-null date rather than trusting row order.
    const dates = rows
      .map(r => r.get('field_payment_date')?.value)
      .filter(d => !!d)
      .sort();
    if (dates.length) {
      this.enrollmentForm.get('field_recurrent_month_day')?.setValue(
        moment(dates[0]).format('YYYY-MM-DD'), { emitEvent: false });
    }

    let interval: number = null;
    if (structureType === 'weekly' || structureType === 'monthly') {
      // Interval = number of installments; the flagged down-payment row is extra.
      interval = rows.filter(r => r.get('field_down_payment')?.value !== true).length;
      this.enrollmentForm.get('installment_split_mode')?.setValue(this.installmentAmountFromRows() !== null ? 'amount' : 'count', { emitEvent: false });
      this.restoreInstallmentAmountInput();
    } else if (structureType === 'by_the_lesson') {
      // Interval = lessons per payment; field_number_lesson_remaining counts
      // down by the interval on each successive row. Sort descending so the
      // derivation doesn't depend on the order rows come back in.
      const remaining = rows
        .map(r => parseInt(r.get('field_number_lesson_remaining')?.value, 10))
        .filter(n => !isNaN(n))
        .sort((a, b) => b - a);
      if (remaining.length > 1) {
        interval = remaining[0] - remaining[1];
      } else if (remaining.length === 1 && remaining[0] > 0) {
        // Single row covering every lesson.
        interval = remaining[0];
      }
    }
    if (interval > 0) {
      this.enrollmentForm.get('interval')?.setValue(interval, { emitEvent: false });
    }
  }

  /** Monthly/weekly builder is splitting by an agreed amount rather than a count. */
  get splitByAmount(): boolean {
    const type = this.enrollmentForm?.get('field_payments_structure_type')?.value;
    return (type === 'monthly' || type === 'weekly') && this.enrollmentForm?.get('installment_split_mode')?.value === 'amount';
  }

  get installmentSentenceStart(): string {
    const remainder = (parseFloat(this.enrollmentForm?.get('field_down_payment_amount')?.value) || 0) > 0;
    if (this.splitByAmount) {
      return remainder ? 'Separate the remainder into payments of' : 'Separate into payments of';
    }
    return remainder ? 'Separate the remainder into' : 'Separate into';
  }

  /**
   * The agreed per-payment amount a saved schedule was built from, pre-tax,
   * or null when it reads as an equal split. Equal installments differ only
   * by the odd cents the last row absorbs; a split by amount has a last row
   * that is a different figure altogether, and all the others identical.
   */
  private installmentAmountFromRows(): number | null {
    const rows = ((this.enrollmentForm?.get('field_scheduled_payments') as FormArray)?.controls ?? [])
      .filter(r => r.get('field_down_payment')?.value !== true)
      .map(r => ({ date: r.get('field_payment_date')?.value ?? '', amount: parseFloat(r.get('field_payment_amount')?.value) || 0 }))
      .sort((a, b) => a.date.localeCompare(b.date));
    if (rows.length < 2) { return null; }
    const first = rows[0].amount;
    const last = rows[rows.length - 1].amount;
    const fullRowsEqual = rows.slice(0, -1).every(r => Math.abs(r.amount - first) < 0.005);
    return fullRowsEqual && last < first - 0.05 ? first : null;
  }

  // Shown incl. tax where the Total column is (that is how it was entered),
  // pre-tax elsewhere; re-run once the studio's tax mode resolves.
  private restoreInstallmentAmountInput(): void {
    const amount = this.installmentAmountFromRows();
    if (amount === null) { return; }
    const rows = ((this.enrollmentForm.get('field_scheduled_payments') as FormArray)?.controls ?? [])
      .filter(r => r.get('field_down_payment')?.value !== true);
    const tax = this.scheduledRowsShowTotal ? (parseFloat(rows[0]?.get('field_tax_amount')?.value) || 0) : 0;
    this.enrollmentForm.get('installment_amount')?.setValue(Math.round((amount + tax) * 100) / 100, { emitEvent: false });
  }

  // The down-payment input is UI-only as well: back-fill it from the flagged
  // row. Tax-on-top studios enter the down payment INCL. tax (the generator
  // backs the pre-tax part out), so restore amount + tax there and the pre-tax
  // amount everywhere else; a re-Generate then round-trips to the same rows.
  // Runs after the load (the tax rate must already be in the form) and again
  // once the studio's tax mode resolves, since the mode decides which value.
  private restoreDownPaymentInput(): void {
    const dpAmountControl = this.enrollmentForm?.get('field_down_payment_amount');
    const rows = (this.enrollmentForm?.get('field_scheduled_payments') as FormArray)?.controls;
    if (!dpAmountControl || !rows || rows.length < 2) { return; }
    const flagged = rows.find(r => r.get('field_down_payment')?.value === true);
    if (!flagged) { return; }
    const amount = parseFloat(flagged.get('field_payment_amount')?.value) || 0;
    const tax = this.scheduledRowsShowTotal ? (parseFloat(flagged.get('field_tax_amount')?.value) || 0) : 0;
    dpAmountControl.setValue(Math.round((amount + tax) * 100) / 100, { emitEvent: false });
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Resolve the studio currency formatter from the already-injected
    // StudioConfigService (see field comment for why this isn't constructor DI).
    this.currencyService = new CurrencyService(this._studioConfigService, new LocalizationService(), this._translateService);

    // Offer back an Add Enrollment that couldn't reach the server earlier.
    if (this.initActionType === 'create') {
      this.loadEnrollmentDraft();
    }

    // Watch for sale date changes to auto-set expiration date
    if (this.enrollmentForm) {
      this.enrollmentForm.get('field_sale_date')?.valueChanges.subscribe(value => {
        if (value && !this.enrollmentForm.get("field_expiration_date").value) {
          // Default the expiration date to 6 months from now
          const expirationDate = moment(value).add(6, 'months');
          const expirationDateFormatted = expirationDate.format('YYYY-MM-DDTHH:mm:ss');
          this.enrollmentForm.get("field_expiration_date").setValue(expirationDateFormatted);
        }

        // Tax rates are date-effective; a backdated sale may fall in a
        // different rate era than today. Edit mode keeps its stored rate and
        // only re-resolves the mode and rows.
        this.applyTaxConfigForSaleDate();
      });
    }
  }

  // Fill an empty Enrollment Date with "now" in the studio's timezone
  // (field_studio_timezone) when the picker is opened. The directive's shared
  // setCurrentTimeOnOpen flag uses the client clock, which is wrong for users
  // browsing from another timezone. Minutes snap down to the picker's
  // 15-minute increment, mirroring that flag's rounding.
  setSaleDateToStudioNow(): void {
    const saleDateControl = this.enrollmentForm?.get('field_sale_date');
    if (!saleDateControl || saleDateControl.value) { return; }
    this._studioConfigService.getStudioConfig()
      .pipe(filter(config => !!config), take(1))
      .subscribe(config => {
        if (saleDateControl.value) { return; }
        const timezone = config?.['field_studio_timezone']?.[0]?.value;
        const now = timezone ? moment.tz(timezone) : moment();
        now.minutes(Math.floor(now.minutes() / 15) * 15).seconds(0).milliseconds(0);
        saleDateControl.setValue(now.format('YYYY-MM-DDTHH:mm:ss'));
      });
  }


  // Helper function to round a number to a fixed number of decimal places
  private roundNumber(num: number, decimalPlaces: number): number {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(num * factor) / factor;
  }

  getOriginalPackageCost(): number {
    if (!this.entityData?.field_enrollment_total_price || !this.entityData?.field_discount_type || !this.entityData?.field_discount) {
      return 0; // Return 0 or another appropriate default value if data is not available
    }

    const packageCost = this.entityData.field_enrollment_total_price;
    const discount = this.entityData.field_discount;
    let result: number;

    if (this.entityData.field_discount_type === 'flat') {
      result = parseFloat(packageCost.toString()) + parseFloat(discount.toString());
    } else if (this.entityData.field_discount_type === 'percentage') {
      result = packageCost / (1 - (discount / 100));
    } else {
      result = packageCost; // Assuming no discount if type is neither 'flat' nor 'percentage'
    }

    // Round the result to a desired number of decimal places
    return this.roundNumber(result, 2); // Here, I'm rounding to 2 decimal places. Adjust as needed.
  }

  getAmountLabel(): string {
    const field_category = this.enrollmentForm?.value?.field_category;
    switch (field_category) {
      case '5': // MISC
        return 'Event Amount';
      case '67': // SUNDRY
        return 'Item Amount';
      default:
        return 'Lesson Amount';
    }
  }

  getTaxTypeLabel(): string {
    if (!this.taxConfig || this.taxConfig.length === 0) {
      return 'Tax';
    }

    const inclusiveTaxes: string[] = [];
    const exclusiveTaxes: string[] = [];

    // Collect all active tax types
    for (const tax of this.taxConfig) {
      const statusValue = Array.isArray(tax.field_tax_status)
        ? tax.field_tax_status[0]?.value
        : tax.field_tax_status;

      const isActive = statusValue === '1' || statusValue === 'true';
      if (!isActive) continue;

      const taxType = Array.isArray(tax.field_tax_type)
        ? tax.field_tax_type[0]?.value
        : tax.field_tax_type;

      const isInclusiveValue = Array.isArray(tax.field_is_tax_inclusive)
        ? tax.field_is_tax_inclusive[0]?.value
        : tax.field_is_tax_inclusive;

      const taxLabel = this.getTaxTypeFriendlyName(taxType);

      if (isInclusiveValue === '1' || isInclusiveValue === 'true' || isInclusiveValue === true) {
        inclusiveTaxes.push(taxLabel);
      } else {
        exclusiveTaxes.push(taxLabel);
      }
    }

    // Build combined label
    if (inclusiveTaxes.length > 0 && exclusiveTaxes.length > 0) {
      return inclusiveTaxes.join('/') + ' + ' + exclusiveTaxes.join('/');
    } else if (inclusiveTaxes.length > 0) {
      return inclusiveTaxes.join('/');
    } else if (exclusiveTaxes.length > 0) {
      return exclusiveTaxes.join('/');
    }

    return 'Tax';
  }

  private getTaxTypeFriendlyName(taxType: string): string {
    return getTaxTypeShortLabel(taxType, 'Tax');
  }

  getFieldTypeBasedOnDepartment(studentDepartment: number): string {
    if (studentDepartment == 75) {
      return "548";
    } else if (studentDepartment == 77) {
      return "600";
    } else {
      return null; // or return a default value if needed
    }
  }

  loadTaxRateFromConfig() {
    this._drupalRESTService.httpGET('/api_rest/v1/loadStudioConfig?config_field_name=field_tax_ref').subscribe(
      (response: any) => {
        if (!response || (Array.isArray(response) && response.length === 0)) {
          LoggerService.log('No tax configuration found');
          this.enrollmentForm.patchValue({ field_tax_percentage: 0 });
          this.calcNewTotal();
          return;
        }

        this.taxConfig = Array.isArray(response) ? response : [response];
        this.applyTaxConfigForSaleDate();
      },
      error => {
        LoggerService.error('Error loading tax rate:', error);
        this.enrollmentForm.patchValue({ field_tax_percentage: 0 });
        this.calcNewTotal();
      }
    );
  }

  // Same config as loadTaxRateFromConfig, without the create-mode fallbacks
  // that write 0 into Taxes % when nothing is configured or the request
  // fails: in edit mode the stored rate must survive either.
  private loadTaxModeFromConfig() {
    this._drupalRESTService.httpGET('/api_rest/v1/loadStudioConfig?config_field_name=field_tax_ref').subscribe(
      (response: any) => {
        if (!response || (Array.isArray(response) && response.length === 0)) {
          return;
        }
        this.taxConfig = Array.isArray(response) ? response : [response];
        this.applyTaxConfigForSaleDate();
      },
      error => {
        LoggerService.error('Error loading tax configuration:', error);
      }
    );
  }

  /**
   * Resolve the loaded tax config into a rate AS OF THE SALE DATE, not today.
   * Tax rates change over time (e.g. Nova Scotia HST 15% → 14% on 2025-04-01)
   * and a backdated or historical enrollment must be taxed at the rate that was
   * in effect when it was sold. Falls back to today's rates when the sale date
   * is empty, or when no config row covers the sale date (so a studio that only
   * configured its current rate keeps today's behavior instead of dropping to 0%).
   * Re-run on sale-date changes; a manually overridden Taxes % is left alone.
   */
  applyTaxConfigForSaleDate() {
    if (!this.taxConfig) {
      return;
    }

    const saleDateValue = this.enrollmentForm?.get('field_sale_date')?.value;
    const saleDate = saleDateValue && moment(saleDateValue).isValid() ? moment(saleDateValue) : moment();

    let rates = this.resolveTaxRatesAsOf(saleDate);
    if (rates.total === 0 && !saleDate.isSame(moment(), 'day')) {
      rates = this.resolveTaxRatesAsOf(moment());
    }

    this.inclusiveTaxRate = rates.inclusive;
    this.exclusiveTaxRate = rates.exclusive;
    this.isTaxInclusive = rates.inclusive > 0;
    this.activeTaxRows = rates.rows;

    // Edit mode: the stored Taxes % stays as it is; only the mode and rows
    // above were needed. Re-derive the totals with them, and the down-payment
    // input, whose value depends on the mode.
    if (this.actionType !== 'create') {
      this.calcNewTotal();
      // Only on the first resolve: later sale-date changes must not overwrite
      // a down payment the user has since typed.
      if (!this.taxModeResolved) {
        this.taxModeResolved = true;
        this.restoreDownPaymentInput();
        this.restoreInstallmentAmountInput();
      }
      return;
    }

    // If the user typed their own Taxes % (field no longer holds the rate we
    // last resolved), the field is theirs. Don't clobber it on a date change.
    const currentRate = parseFloat(this.enrollmentForm.get('field_tax_percentage')?.value);
    if (this.lastResolvedTaxRate !== null && !isNaN(currentRate) && currentRate !== this.lastResolvedTaxRate) {
      return;
    }

    if (rates.total === 0) {
      LoggerService.log('No applicable percentage-based taxes found');
      this.lastResolvedTaxRate = 0;
      this.enrollmentForm.patchValue({ field_tax_percentage: 0 });
      this.calcNewTotal();
      return;
    }

    // The rate keeps its configured precision (Quebec QST is 9.975%). The
    // rounding rule governs dollar amounts, never the percentage itself.
    // toFixed(4) only strips float-addition artifacts from summing the rows.
    const resolvedTaxRate = parseFloat(rates.total.toFixed(4));

    this.lastResolvedTaxRate = resolvedTaxRate;
    this.enrollmentForm.patchValue({ field_tax_percentage: resolvedTaxRate });
    this.calcNewTotal();
  }

  private resolveTaxRatesAsOf(asOf: moment.Moment): { total: number; inclusive: number; exclusive: number; rows: Array<{ rate: number; inclusive: boolean; roundingRule: string }> } {
    let total = 0;
    let inclusive = 0;
    let exclusive = 0;
    const rows: Array<{ rate: number; inclusive: boolean; roundingRule: string }> = [];

    (this.taxConfig || []).forEach(tax => {
      const statusValue = Array.isArray(tax.field_tax_status)
        ? tax.field_tax_status[0]?.value
        : tax.field_tax_status;

      const isActive = statusValue === '1' || statusValue === 'true';
      if (!isActive) {
        return;
      }

      const startDate = tax.field_effective_tax_start_date?.[0]?.value ? moment(tax.field_effective_tax_start_date[0].value) : null;
      const endDate = tax.field_effective_tax_end_date?.[0]?.value ? moment(tax.field_effective_tax_end_date[0].value) : null;

      // Day granularity: a sale at 2pm on the rate's last effective day still
      // belongs to that rate era even though the config stores midnight.
      if ((!startDate || asOf.isSameOrAfter(startDate, 'day')) && (!endDate || asOf.isSameOrBefore(endDate, 'day'))) {
        const calculationMethod = Array.isArray(tax.field_calculation_method)
          ? tax.field_calculation_method[0]?.value
          : tax.field_calculation_method;

        const taxValue = Array.isArray(tax.field_tax_value)
          ? parseFloat(tax.field_tax_value[0]?.value)
          : parseFloat(tax.field_tax_value);

        if (calculationMethod === 'PERCENTAGE' && !isNaN(taxValue)) {
          total += taxValue;

          const isInclusiveValue = Array.isArray(tax.field_is_tax_inclusive)
            ? tax.field_is_tax_inclusive[0]?.value
            : tax.field_is_tax_inclusive;
          const isInclusive = isInclusiveValue === '1' || isInclusiveValue === 'true' || isInclusiveValue === true;

          if (isInclusive) {
            inclusive += taxValue;
          } else {
            exclusive += taxValue;
          }

          const roundingRule = Array.isArray(tax.field_rounding_rule)
            ? tax.field_rounding_rule[0]?.value
            : tax.field_rounding_rule;
          rows.push({ rate: taxValue, inclusive: isInclusive, roundingRule: roundingRule || 'ROUND_NEAREST' });
        }
      }
    });

    return { total, inclusive, exclusive, rows };
  }

  showParentSignature() {
    this.detectSignatureParent = true;
    // Initialize the parent signature canvas after making it visible
    setTimeout(() => {
      if (this.signatureParent) {
        this.signatureInit(this.signatureParent, 'parent');
      }
    }, 0);
  }

  calculateTotalTuition() {
    const originalCost = this.getOriginalPackageCost();
    let discountedCost = originalCost;

    if (this.entityData?.field_discount_type === 'percentage') {
      const discountPercentage = this.entityData?.field_discount || 0;
      discountedCost = originalCost * (1 - discountPercentage / 100);
    } else if (this.entityData?.field_discount_type === 'flat') {
      const discountAmount = this.entityData?.field_discount || 0;
      discountedCost = originalCost - discountAmount;
    }

    const taxRate = this.entityData?.field_tax_percentage || 0;
    const taxAmount = discountedCost * (taxRate / 100);

    return discountedCost + taxAmount;
  }

  checkStudentBalanceLimit(studentAccountId: string) {
    studentAccountId = this.regexStudentName(studentAccountId);

    const endpoint = '/api_rest/v1/checkStudentBalanceLimit';

    if (this.actionType !== 'create') {
      this.studentBalanceWarning = null;
      return; // Only check balance limit in create mode
    }

    const studioReferenceId = this._authService.selectedStudio?.id;
    if (!studioReferenceId) {
      this.studentBalanceWarning = null;
      return;
    }

    this._drupalRESTService.httpGET(endpoint + '?studentAccountId=' + studentAccountId + '&field_studio_reference_target_id=' + studioReferenceId).subscribe(
      (response: any) => {
        if (!response || (Array.isArray(response) && response.length === 0)) {
          LoggerService.log('No response from checkStudentBalanceLimit');
          this.studentBalanceWarning = null;
          return;
        }

        this.studentBalanceData = response;

        if (!response.is_under_threshold) {
          this.studentBalanceWarning = `Balance limit exceeded. Total: ${this.currencyService.format(response.total_balance)}, Remaining: ${this.currencyService.format(response.remaining_amount)}`;
        } else {
          this.studentBalanceWarning = null;
        }

        this.calcNewTotal();
      },
      (error) => {
        LoggerService.error('Error checking student balance limit:', error);
        this.studentBalanceWarning = null;
      }
    );
  }

  // Override to handle deferred enrollment creation
  override async onSubmitSignatures(action: string): Promise<void> {
    // Only create enrollment when a save action is clicked and we have temp data.
    // 'save_and_email' must be included: emailing a not-yet-created enrollment
    // would post an undefined enrollmentID and never reach the student.
    if ((action === 'save_and_add' || action === 'save_and_pay' || action === 'save_and_email') && this.tempEnrollmentData && this.actionType === 'create') {
      // A save is already running. The buttons stay clickable behind the
      // progress shade, and two clicks used to race past the tempEnrollmentData
      // check and post the enrollment twice.
      if (this.savingEnrollment) {
        return;
      }
      this.savingEnrollment = true;
      this.displayProgressSpinner(true);

      try {
        // Attach the selected enrollment agreement before saving
        if (this.activeAgreementId) {
          this.tempEnrollmentData.field_enrollment_agreement = this.activeAgreementId;
        }

        // Create the enrollment first, or update the one this dialog already
        // created when the rep went Back, changed something and saved again.
        const enrollmentData = this.createdEnrollmentId
          ? await this._entityRESTService.patchEntity(
              this.eckType,
              this.bundle,
              this.createdEnrollmentId,
              this.tempEnrollmentData
            ).toPromise()
          : await this._entityRESTService.createEntity(
              this.eckType,
              this.bundle,
              this.tempEnrollmentData
            ).toPromise();

        // Update entity IDs and data
        const savedEnrollmentId = (enrollmentData && Array.isArray(enrollmentData['id']) &&
          enrollmentData['id'].length > 0 && enrollmentData['id'][0].value)
          ? enrollmentData['id'][0].value
          : this.createdEnrollmentId;

        if (savedEnrollmentId) {
          this.createdEnrollmentId = savedEnrollmentId;
          this.entityId = savedEnrollmentId;
          this.enrollmentID = savedEnrollmentId;

          // This student's enrollment is on file now, so a draft kept for
          // them is done with.
          const draft = this.readEnrollmentDraft();
          if (draft && String(draft.studentId) === String(enrollmentData?.['field_student']?.[0]?.target_id)) {
            this.discardEnrollmentDraft();
          }

          // Load fresh enrollment data
          this.entityData = await this._entityRESTService.getEntity(
            'packages', 'enrollment', this.entityId
          ).toPromise();
          this.enrollmentEntityData = this.entityData;
          this._enrollmentEntityData = this.entityData;

          // Load student account data if needed
          if (enrollmentData && Array.isArray(enrollmentData['field_student']) &&
              enrollmentData['field_student'].length > 0 && enrollmentData['field_student'][0].target_id) {
            this.studentAccountEntityData = await this._entityRESTService.getEntity(
              'student_accounts', 'student_account', enrollmentData['field_student'][0].target_id
            ).toPromise();
            this.loadContactData();
          }

          // Clear temp data since enrollment is now saved
          this.tempEnrollmentData = null;
          this.dataSaved = true;
        }
      } catch (error) {
        this.savingEnrollment = false;
        this.displayProgressSpinner(false);

        // Navigate back to step 1 so user can see the error and fix it
        LoggerService.log('Enrollment save failed, navigating back to step 1', error);
        LoggerService.log('Current stepper index before navigation:', this.enrollmentStepper?.selectedIndex);

        // Use previous() to go back, which works similar to the Back button
        if (this.enrollmentStepper) {
          this.enrollmentStepper.previous();
          this.enrollmentStepperIndex = 0;
          LoggerService.log('Stepper index after navigation:', this.enrollmentStepper.selectedIndex);
        }

        this.handleError(error);
        return;
      }

      this.savingEnrollment = false;
    }

    // Continue with normal signature processing
    await super.onSubmitSignatures(action);
  }

  // No response while adding an enrollment: keep what was typed before the
  // dialog closes. Skipped once this dialog has created the enrollment, since
  // that one is on file and can be finished from the list.
  override handleError(error: any) {
    if (error?.status == 0 && this.actionType === 'create' && !this.createdEnrollmentId) {
      this.saveEnrollmentDraft();
    }
    super.handleError(error);
  }

  // One draft per user and studio in this browser; a newer one replaces it.
  private get enrollmentDraftKey(): string {
    return `amt_enrollment_draft_${this._authService.current_user?.['uid']}_${this._authService.selectedStudio?.id}`;
  }

  private saveEnrollmentDraft(): void {
    const values = this.enrollmentForm?.getRawValue();
    const student = values?.field_student ? String(values.field_student) : '';
    if (!student) {
      return;
    }

    const draft = {
      savedAt: Date.now(),
      studentName: student.replace(/\s*\(\d+\)$/, ''),
      studentId: /^\d+$/.test(student) ? student : this.regexStudentName(student),
      saleDate: values.field_sale_date ? moment(values.field_sale_date).format('YYYY-MM-DD') : '',
      values,
    };
    try {
      localStorage.setItem(this.enrollmentDraftKey, JSON.stringify(draft));
      this.noResponseMessage = "Couldn't reach the server, so this enrollment may not have saved. What you entered is kept on this computer. Open Add Enrollment again to restore it.";
    } catch {
      // Storage full or blocked: the plain no-response message still shows.
    }
  }

  private readEnrollmentDraft(): any {
    try {
      const draft = JSON.parse(localStorage.getItem(this.enrollmentDraftKey));
      // After a week a draft is more likely to mislead than help.
      if (draft?.values && Date.now() - draft.savedAt < 7 * 24 * 60 * 60 * 1000) {
        return draft;
      }
    } catch {
      // Unreadable storage counts as no draft.
    }
    return null;
  }

  private loadEnrollmentDraft(): void {
    this.enrollmentDraft = this.readEnrollmentDraft();
    if (!this.enrollmentDraft?.studentId || !this.enrollmentDraft.saleDate) {
      return;
    }

    // The save may have gone through with only its reply lost. Look for an
    // enrollment for the same student within a day of the sale date (a day
    // either side absorbs timezone differences in the stored date).
    const saleDate = moment(this.enrollmentDraft.saleDate);
    const range = saleDate.clone().subtract(1, 'day').format('YYYY-MM-DD') + '--' + saleDate.clone().add(1, 'day').format('YYYY-MM-DD');
    this._drupalRESTService.httpGET('/api/v1/enrollment-list', [
      { parameter: 'id', value: this.enrollmentDraft.studentId },
      { parameter: 'field_sale_date', value: range },
    ]).subscribe(data => {
      this.enrollmentDraftExistingId = data?.['results']?.[0]?.id ?? null;
    }, () => {});
  }

  restoreEnrollmentDraft(): void {
    const values = this.enrollmentDraft?.values;
    if (!values) {
      return;
    }

    // patchValue only fills rows that already exist, so rebuild them first.
    const rebuildRows = (name: string, addRow: (row: any) => void) => {
      const rows = this.enrollmentForm.get(name) as FormArray;
      rows.clear();
      (values[name] || []).forEach(row => addRow(row));
    };
    rebuildRows('field_instructor_percentages', () => this.instructorPercentageIncrement());
    rebuildRows('field_scheduled_payments', row => {
      this.scheduledPaymentIncrement();
      // By-the-lesson rows after the first have no date, and the generator
      // doesn't require one there. Match it or the restored plan is invalid.
      if (!row?.field_payment_date) {
        const rows = this.enrollmentForm.get('field_scheduled_payments') as FormArray;
        rows.at(rows.length - 1).get('field_payment_date').clearValidators();
      }
    });
    rebuildRows('payment_builder_date_step', () => this.paymentPlanGeneratorIncreaseStep());

    // emitEvent: false, or the sale-date and price watchers re-derive the tax
    // rate, expiration date and payment plan mid-patch and overwrite it.
    this.enrollmentForm.patchValue(values, { emitEvent: false });
    this.is_pay_in_full = values.field_payments_structure === 'paid_in_full';
    this.is_use_installments = values.field_payments_structure === 'installments';
    this.calcNewTotal();
    this.checkStudentBalanceLimit(values.field_student);

    // Hide the banner. The stored copy stays until the enrollment saves.
    this.enrollmentDraft = null;
  }

  discardEnrollmentDraft(): void {
    try {
      localStorage.removeItem(this.enrollmentDraftKey);
    } catch {
      // Nothing to clean up if storage is unavailable.
    }
    this.enrollmentDraft = null;
  }

  // Helper function to ensure numeric values are valid
  private ensureValidNumber(value: any): number {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }

  // Method to save enrollment and close dialog
  saveAndCloseDialog() {
    this.errorMessage = "";
    this.displayProgressSpinner(true);

    // Calculate instructor percentages
    this.fromPercentCalcTotal();

    // Calculate Pay In Full or Installments
    if (this.is_pay_in_full) {
      this.paid_in_full();
    }

    const values = { ...this.enrollmentForm.value };

    if (this.actionType === "create") {
      // For create mode, save the enrollment directly
      this.__alterValues(values);

      this._entityRESTService.createEntity(this.eckType, this.bundle, values)
        .subscribe(data => {
          this.displayProgressSpinner(false);
          this._dialogRef.close({ saved: true, data: data });
        },
          error => {
            this.displayProgressSpinner(false);
            // Navigate back to step 1 so user can see the error and fix it
            if (this.enrollmentStepper) {
              this.enrollmentStepper.previous();
              this.enrollmentStepperIndex = 0;
            }
            this.handleError(error);
          }
        );
    } else {
      // For edit mode, patch the existing enrollment
      this.__alterValues(values);

      this._entityRESTService.patchEntity(this.eckType, this.bundle, this.entityId, values)
        .subscribe(data => {
          this.displayProgressSpinner(false);
          this._dialogRef.close({ saved: true, data: data });
        },
          error => {
            this.displayProgressSpinner(false);
            // Navigate back to step 1 so user can see the error and fix it
            if (this.enrollmentStepper) {
              this.enrollmentStepper.previous();
              this.enrollmentStepperIndex = 0;
            }
            this.handleError(error);
          }
        );
    }
  }

  /**
   * Load the agreement template key.
   * - For existing enrollments with field_enrollment_agreement set: use that agreement's template key (what they signed)
   * - For new/legacy enrollments: load from the studio's available agreements and use the default
   */
  private loadAgreementTemplateKey(): void {
    // If viewing an existing enrollment that has an agreement reference, use it
    const agreementRef = this.entityData?.field_enrollment_agreement;

    // Handle expanded entity object (API returns full entity) or reference format
    if (agreementRef && typeof agreementRef === 'object' && agreementRef.id) {
      // Expanded entity: template key is directly available
      this.activeTemplateKey = agreementRef.field_template_key || 'amdc_standard';
      this.activeAgreementId = agreementRef.id;
      this.generateBackpageDisplayContent();
      return;
    }

    // Handle reference format {target_id: X}
    const agreementId = Array.isArray(agreementRef)
      ? agreementRef[0]?.target_id
      : agreementRef?.target_id;

    if (agreementId) {
      this._drupalRESTService.httpGET('/api_rest/v1/loadEnrollmentAgreements')
        .subscribe((agreements: any[]) => {
          const match = agreements?.find(a => a.id === agreementId.toString());
          if (match?.field_template_key?.[0]?.value) {
            this.activeTemplateKey = match.field_template_key[0].value;
            this.activeAgreementId = agreementId.toString();
            // The back page depends on the template key. Regenerate now that it's known.
            this.generateBackpageDisplayContent();
          }
        });
      return;
    }

    // No agreement ref on enrollment: use studio's selected default, fall back to US Standard
    this._drupalRESTService.httpGET('/api_rest/v1/loadEnrollmentAgreements')
      .subscribe((agreements: any[]) => {
        if (!agreements || agreements.length === 0) return;

        const defaultAgreement = agreements.find(a => a.field_is_default?.[0]?.value === '1');
        if (defaultAgreement?.field_template_key?.[0]?.value) {
          this.activeTemplateKey = defaultAgreement.field_template_key[0].value;
          this.activeAgreementId = defaultAgreement.id;
          // The back page depends on the template key. Regenerate now that it's known.
          this.generateBackpageDisplayContent();
        }
        // If no default is selected, activeTemplateKey stays 'amdc_standard'
      });
  }

}

